import { TState } from 'store/store'

export const getProfile = (state: TState) => state.profile.data
export const getDefaultEntertainmentCenter = (state: TState) => state.profile.data?.company.defaultEntertainmentCenter
export const getIsAddressMatchedProfile = (state: TState) => state.profile.data?.company.isAddressMatched
export const getIsCalculationAgreed = (state: TState) => state.profile.data?.company.isCalculationAgreed
